import { render, staticRenderFns } from "./MaintenanceReminder.vue?vue&type=template&id=e523bc52&scoped=true&"
import script from "./MaintenanceReminder.vue?vue&type=script&lang=js&"
export * from "./MaintenanceReminder.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceReminder.vue?vue&type=style&index=0&id=e523bc52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e523bc52",
  null
  
)

export default component.exports